import { render, staticRenderFns } from "./SalarieIndex.vue?vue&type=template&id=1d28e2e3&scoped=true"
import script from "./SalarieIndex.vue?vue&type=script&lang=js"
export * from "./SalarieIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28e2e3",
  null
  
)

export default component.exports